import { Action } from '@ngrx/store';

export const GET_LAB_INFO = 'Get Lab Info';
export const GET_LAB_INFO_SUCCESS = 'Get Lab Info Success';
export const GET_LAB_INFO_FAILURE = 'Get Lab Info Failure';

export const GET_NUM_ASSIGNED_KITS = 'Get Num Assigned Kits';
export const GET_NUM_ASSIGNED_KITS_SUCCESS = 'Get Num Assigned Kits Success';

export const GET_KITS_FOR_LAB = 'Get Kits for Lab';
export const GET_KITS_FOR_LAB_SUCCESS = 'Get Kits for Lab Success';

export const AFFILIATE_AND_REGISTER = 'Affiliate and Register';
export const AFFILIATE_USER_TO_LAB = 'Affiliate User To Lab';
export const AFFILIATE_USER_TO_LAB_QMED = 'Affiliate User To Lab QMed';
export const AFFILIATE_USER_TO_LAB_SUCCESS = 'Affiliate User To Lab Success';

export const GET_LAB_SELECT_DATA = 'Get Lab Select Data';
export const GET_LAB_SELECT_DATA_SUCCESS = 'Get Lab Select Data Success';

export const ASSIGN_KIT_TO_USER = 'Assign Kit to User';
export const ASSIGN_KIT_TO_USER_SUCCESS = 'Assign Kit to User Success';
export const ASSIGN_KIT_TO_USER_FAILURE = 'Assign Kit to User Failure';

export const ENTER_CAP = 'Enter CAP';
export const SELECT_LAB = 'Select Lab from Dropdown';

export const ALL_KITS_USED = 'All Kits Used';
export const KITS_NOT_PURCHASED = 'Kits Not Purchased';
export const KITS_UNFULFILLED = 'Kits Unfulfilled';
export const QMED_ACTIVITY_NOT_AVAILABLE = 'QMed Activity Not Available';

export const CLOSE_CONFIRMATION = 'Close Confirmation';

export class GetLabInfo implements Action {
  readonly type = GET_LAB_INFO;

  constructor(public labCapNumber: string) {}
}

export class GetLabInfoSuccess implements Action {
  readonly type = GET_LAB_INFO_SUCCESS;

  constructor(public payload) {}
}

export class GetLabInfoFailure implements Action {
  readonly type = GET_LAB_INFO_FAILURE;

  constructor(public payload) {}
}

export class GetKitsForLab implements Action {
  readonly type = GET_KITS_FOR_LAB;

  constructor(public activityId: string, public labCapNumber: string) {}
}

export class GetKitsForLabSuccess implements Action {
  readonly type = GET_KITS_FOR_LAB_SUCCESS;

  constructor(public payload) {}
}

export class AffiliateUserToLab implements Action {
  readonly type = AFFILIATE_USER_TO_LAB;

  constructor(
    public activity: any,
    public labCapNumber: string,
    public mailingCode: string
  ) {}
}
export class AffiliateUserToLabQmed implements Action {
  readonly type = AFFILIATE_USER_TO_LAB_QMED;
  constructor(public activity: any, public labCapNumber: string) {}
}

export class AffiliateUserToLabSuccess implements Action {
  readonly type = AFFILIATE_USER_TO_LAB_SUCCESS;

  constructor() {}
}

export class AssignKitToUser implements Action {
  readonly type = ASSIGN_KIT_TO_USER;

  constructor(public activityId: string, public labCapNumber: string) {}
}

export class AssignKitToUserSuccess implements Action {
  readonly type = ASSIGN_KIT_TO_USER_SUCCESS;

  constructor(public payload) {}
}

export class AssignKitToUserFailure implements Action {
  readonly type = ASSIGN_KIT_TO_USER_FAILURE;

  constructor(public payload) {}
}

export class EnterCap implements Action {
  readonly type = ENTER_CAP;

  constructor() {}
}

export class SelectLabFromDropdown implements Action {
  readonly type = SELECT_LAB;

  constructor() {}
}

export class AllKitsUsed implements Action {
  readonly type = ALL_KITS_USED;

  constructor() {}
}

export class KitsNotPurchased implements Action {
  readonly type = KITS_NOT_PURCHASED;

  constructor() {}
}

export class KitsUnfulfilled implements Action {
  readonly type = KITS_UNFULFILLED;

  constructor() {}
}

export class QMedActivityNotAvailable implements Action {
  readonly type = QMED_ACTIVITY_NOT_AVAILABLE;
  constructor() {}
}
export class GetLabSelectData implements Action {
  readonly type = GET_LAB_SELECT_DATA;

  constructor(public activityCode: number) {}
}

export class GetLabSelectDataSuccess implements Action {
  readonly type = GET_LAB_SELECT_DATA_SUCCESS;

  constructor(public payload) {}
}

export class CloseConfirmation implements Action {
  readonly type = CLOSE_CONFIRMATION;

  constructor() {}
}

export type LmsActions =
  | GetLabInfo
  | GetLabInfoSuccess
  | GetLabInfoFailure
  | AffiliateUserToLab
  | AffiliateUserToLabSuccess
  | AssignKitToUser
  | AssignKitToUserSuccess
  | AssignKitToUserFailure
  | AllKitsUsed
  | KitsNotPurchased
  | KitsUnfulfilled
  | QMedActivityNotAvailable
  | EnterCap
  | SelectLabFromDropdown
  | GetLabSelectData
  | GetLabSelectDataSuccess
  | CloseConfirmation;
